import type { Meta, StoryObj } from '@storybook/react';
import { Copy } from '../Copy';

const meta: Meta<typeof Copy> = {
  title: 'Components/Copy',
  component: Copy,
};

export default meta;
type Story = StoryObj<typeof Copy>;

const AMOUNT = 109313489123.49;

export const Default: Story = {
  args: {
    value: AMOUNT.toString(),
    children: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(AMOUNT),
  },
};

export const Button: Story = {
  args: {
    value: AMOUNT.toString(),
    children: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(AMOUNT),
    variant: 'button',
  },
};
